export const item = {
  somethingWentWrong: 'Algo salió mal',
  checkAvailability: 'Chequear disponibilidad',
  publishedBy: 'Publicado por'
}



// WEBPACK FOOTER //
// ./src/sections/items/text.js